import { useCallback, useState } from "react";
import { useAnimatedStyle, useSharedValue, withTiming } from "react-native-reanimated";

type UseFadeAnimationProps = {
    initialText: string;
};

const TIMING = 1000;

export const useFadeAnimation = ({ initialText }: UseFadeAnimationProps) => {
    const [text, setText] = useState(initialText);
    const opacity = useSharedValue(1);

    const opacityStyle = useAnimatedStyle(() => ({
        opacity: opacity.value,
    }));

    const _setText = useCallback(
        (newText: string) => {
            opacity.value = withTiming(0, { duration: TIMING / 2 }, (finished) => {
                if (finished) {
                    setText(newText);
                    opacity.value = withTiming(1, { duration: TIMING / 2 });
                }
            });
        },
        [opacity],
    );

    return [text, _setText, opacityStyle] as const;
};
